export enum WeekDaysEnum {
  ValidValue = '9A2D601E-2A10-4958-942D-160E11E992A7',
  Sunday    = '00000770-0000-0000-0000-000000000001',
  Monday    = '00000770-0000-0000-0000-000000000002',
  Tuesday   = '00000770-0000-0000-0000-000000000003',
  Wednesday = '00000770-0000-0000-0000-000000000004',
  Thursday  = '00000770-0000-0000-0000-000000000005',
  Friday    = '00000770-0000-0000-0000-000000000006',
  Saturday  = '00000770-0000-0000-0000-000000000007',
}
